import { loadSiteMetadata as reduxSiteMetadata } from '@raywhite/redux/lib/meta'
import { PRICE_INTERVAL } from '../../constants'

export function loadOfficeSiteMetadata(api, ids) {
  return (dispatch, getState) => reduxSiteMetadata(api, ids, PRICE_INTERVAL)(dispatch, getState)
}
